/**
 * The reader's preferred language (Settings → General → Languages), picked
 * from the tenant's `pwa.json`: `languages` are the choices and
 * `defaultLanguage` (`config.build.language` after `prepare.ts`) is where a
 * reader starts.
 */

/**
 * The languages a reader can choose, in the tenant's order. The default is
 * always one of them, first if the tenant forgot to list it.
 */
export function preferredLanguageOptions(
	defaultLanguage: string,
	languages: ReadonlyArray<string> | undefined,
): Array<string> {
	const listed = [...new Set(languages ?? [])];
	return listed.includes(defaultLanguage) ? listed : [defaultLanguage, ...listed];
}

/**
 * The saved choice while the tenant still offers it, otherwise the default:
 * a language dropped from `languages` after a reader picked it doesn't
 * leave the app (and the Settings select) on a language it no longer has.
 */
export function resolvePreferredLanguage(
	saved: string | null | undefined,
	defaultLanguage: string,
	languages: ReadonlyArray<string> | undefined,
): string {
	return saved && preferredLanguageOptions(defaultLanguage, languages).includes(saved)
		? saved
		: defaultLanguage;
}
